import React, { useState, useEffect } from 'react';
import '../Components/ComponentCss/Tabs.css'; // CSS 파일 임포트

const Tabs = ({ rooms, onTabSelect }) => {
    // 기본값을 배열의 첫 번째 값으로 설정
    const [selectedTab, setSelectedTab] = useState(rooms[0]);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const handleTabSelect = (tabName, index) => {
        setSelectedTab(tabName);
        if (onTabSelect) {
            onTabSelect(tabName); // 부모 컴포넌트로 선택된 탭 전달
        }
    };

    // selectedTab 변경 시 인디케이터 스타일 업데이트
    useEffect(() => {
        const selectedTabIndex = rooms.indexOf(selectedTab);
        const tabElement = document.getElementById(`my-tab-${selectedTabIndex}`);
        if (tabElement) {
            setIndicatorStyle({
                width: `${tabElement.offsetWidth}px`,
                left: `${tabElement.offsetLeft}px`,
            });
        }
    }, [selectedTab, rooms]); // selectedTab이 변경될 때마다 실행

    return (
        <div className="my-tabs-container">
            <div className="my-tabs">
                {rooms.map((room, index) => (
                    <div
                        id={`my-tab-${index}`}
                        key={room}
                        className={`my-tab ${selectedTab === room ? 'active' : ''}`}
                        onClick={() => handleTabSelect(room, index)}
                    >
                        {room}
                    </div>
                ))}
                <div className="my-indicator" style={indicatorStyle}></div>
            </div>
        </div>
    );
};

export default Tabs;
